/**
 * Aggressively clean AI-generated text output.
 * Strips common AI preambles, markdown, smart quotes, and formatting artifacts.
 * Used by EventWorkspace AI Generate, GiGiBot fill_description, and VendorDashboard AI.
 */
export default function cleanAiText(text) {
  if (!text) return '';

  // Strip wrapping quotes
  text = text.replace(/^["']|["']$/g, '').trim();

  // Common AI preambles — ordered by specificity (longer patterns first)
  text = text.replace(/^(Here is a|Here's|Here are) .*?:?\s*/i, '');
  text = text.replace(/^(Sure|OK|Alright|Certainly|Absolutely|Of course|Great|Perfect|No problem|Got it|Here you go|Below is)[,!.].*?:?\s*/i, '');
  text = text.replace(/^I'd (be happy to |suggest|recommend):?\s*/i, '');
  text = text.replace(/^I would (suggest|recommend):?\s*/i, '');
  text = text.replace(/^(You could|How about|Maybe try|Perhaps):?\s*/i, '');
  text = text.replace(/^I can (help with that|certainly do that)[.!]?\s*/i, '');
  text = text.replace(/^(I hope this helps|Let me know if you need|Feel free to ask)[.!]?\s*/i, '');

  // Bold header patterns: **Something:** or **Something**:
  text = text.replace(/^\*\*.*?\*\*\s*:?\s*/i, '');

  // Label prefixes
  text = text.replace(/^(Description|Event Description|Business Description):?\s*/i, '');

  // Strip markdown formatting
  text = text.replace(/\*\*/g, '');
  text = text.replace(/\*/g, '');
  text = text.replace(/#{1,6}\s*/g, '');
  text = text.replace(/`{1,3}/g, '');

  // Smart quotes → straight quotes
  text = text.replace(/[\u201C\u201D]/g, '"');
  text = text.replace(/[\u2018\u2019]/g, "'");

  // Collapse multiple newlines
  text = text.replace(/\n{3,}/g, '\n\n');

  // Remove leading/trailing whitespace
  text = text.trim();

  // Capitalize first letter if lowercase
  if (text.length > 0 && text[0] !== text[0].toUpperCase()) {
    text = text[0].toUpperCase() + text.slice(1);
  }

  // Truncate at last sentence boundary within 500 chars
  if (text.length > 500) {
    const truncated = text.substring(0, 500);
    const lastPeriod = truncated.lastIndexOf('.');
    const lastExclaim = truncated.lastIndexOf('!');
    const lastQuestion = truncated.lastIndexOf('?');
    const lastBoundary = Math.max(lastPeriod, lastExclaim, lastQuestion);
    text = lastBoundary > 300 ? truncated.substring(0, lastBoundary + 1) : truncated + '...';
  }

  return text;
}
